<template>
  <v-reports
  v-if="access.report_taxes"
    v-model="page"
    v-bind:headers="headers"
    v-bind:update="update"
    v-bind:data="data"
    v-bind:numPages="numPages"
    :data_loading="data_loading"
    @change-pagination="changePagination"
  >
    <template #header>
      <v-card>
        <v-card-text>
          <v-layout row>
            <v-flex md4 sm12 xs12 px-3>
              <div>{{ $t(`taxable_sales`) }}</div>
              <p class="display-1 text--primary text-center">
                {{ taxable_sales }}
              </p>
            </v-flex>
            <v-flex md4 sm12 xs12 px-3>
              <div>{{ $t(`non_taxable_sales`) }}</div>
              <p class="display-1 text--primary text-center">
                {{ non_taxable_sales }}
              </p>
            </v-flex>
            <v-flex md4 sm12 xs12 px-3>
              <div>{{ $t(`total_net_sales`) }}</div>
              <p class="display-1 text--primary text-center">
                {{ total_net_sales }}
              </p>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </template>
  </v-reports>
  <error404 v-else></error404>
</template>
<script>
export default {
  name: "ReportsTaxes",
  data: () => ({
    headers: [
      { text: "Tax name", value: "name", available: true, disabled: true },
      // {text: 'Tax rate', value: 'tax_rate', available: true},
      { text: "Taxable sales", value: "taxable_sales", available: true },
      { text: "Tax amount", value: "tax_amount", available: true },
    ],
    data: [],
    params: {},
    page: 1,
    numPages: 1,
    data_loading: false,
    taxable_sales: 0,
    non_taxable_sales: 0,
    total_net_sales: 0,
    access:null
  }),
  methods: {
    changePagination(page) {
      this.page = page;
      this.update(this.params);
    },
    async update(params) {
      this.data_loading = true;
      var start_date = new Date(params.start_date).getTime();
      var end_date = new Date(params.end_date).getTime();
      var taxes = this.$communicator.then(
        this,
        await this.$communicator("by_tax", {
          arguments: [start_date, end_date, 10, this.page],
          params: {
            custom: params.custom,
            start: params.start.time,
            end: params.end.time,
            services: params.service != "" ? [params.service] : [],
            employees: params.employee._id != "" ? [params.employee._id] : [],
          },
        })
      );
      taxes.data = taxes.taxes;
      for (let i = 0; i < taxes.data.length; i++) {
        taxes.data[i].tax_amount = Math.round(
          taxes.data[i].tax_amount
        ).toLocaleString();
        taxes.data[i].taxable_sales = Math.round(
          taxes.data[i].taxable_sales
        ).toLocaleString();
        var time = new Date(taxes.data[i].date);
        taxes.data[i].date =
          time.getDate() + "/" + (time.getDay() + 1) + "/" + time.getFullYear();
        taxes.data[i].type = taxes.data[i].is_refund ? "refund" : "sale";
      }
      this.data = taxes.data;
      this.taxable_sales = Math.round(taxes.taxable_sales).toLocaleString();
      this.non_taxable_sales = Math.round(
        taxes.non_taxable_sales
      ).toLocaleString();
      this.total_net_sales = Math.round(taxes.total_net_sales).toLocaleString();
      this.data_loading = false;
      this.numPages = taxes.page;
    },
  },
  mounted() {
    this.headers = [
      {
        text: this.$t(`tax_name`),
        value: "name",
        available: true,
        disabled: true,
      },
      {
        text: this.$t(`taxable_sales`),
        value: "taxable_sales",
        available: true,
      },
      { text: this.$t(`tax_amount`), value: "tax_amount", available: true },
    ];
    for (const index in this.headers) {
      this.headers[index]["sortable"] = false;
    }
  },
  beforeMount() {
    this.access = this.$store.state.access;
  },
};
</script>
